import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '@nrwl/rx-service-auth';

@Component({
  selector: 'rx-idle-user',
  templateUrl: './rx-idle-user.component.html',
  styleUrls: ['./rx-idle-user.component.scss'],
})
export class RxIdleUserComponent implements OnInit, OnDestroy {
  public counter = 60;
  public counterInterval;

  constructor(private _authService: AuthService) {}

  public ngOnInit() {
    this.counterInterval = setInterval(() => {
      this.counter--;
      if (this.counter === 0) {
        clearInterval(this.counterInterval);
        this._authService.inactiveUserLogout();
      }
    }, 1000);
  }

  public ngOnDestroy() {
    clearInterval(this.counterInterval);
  }
}
